import Vue from "vue";
import Moment from "moment";
import VuemomentJS from "vue-momentjs";

const state = {
  orders: [],
  order: {},
  totalOrders: 0,
  orderStatuses: []
};

const getters = {};

const actions = {
  LOAD_ORDERS: async function({ commit, rootState }, payload) {
    let surgeryIdQuery = payload.surgeryId
      ? "&surgeryId=" + payload.surgeryId
      : "";
    let orderStatusQuery = payload.orderStatus
      ? "&orderStatusId=" + payload.orderStatus
      : "";
    let orderNumberQuery = payload.orderNumber
      ? "&orderNumber=" + payload.orderNumber
      : "";
    return await Vue.prototype.$axios
      .get(
        "/orders?from=" +
          payload.from +
          "&limit=" +
          payload.to +
          surgeryIdQuery +
          orderStatusQuery +
          orderNumberQuery
      )
      .then(
        response => {
          commit("SET_ORDERS", response.data.orders);
          commit("SET_TOTAL_ORDERS", response.data.meta.total);
          return response;
        },
        err => {
          throw new Error(err);
        }
      );
  },
  LOAD_ORDER: async function({ commit }, payload) {
    return await Vue.prototype.$axios.get("/orders/" + payload).then(
      response => {
        commit("SET_ORDER", response.data.order);
      },
      err => {
        throw new Error(err);
      }
    );
  },
  LOAD_ORDER_STATUSES: async function({ commit }, payload) {
    return await Vue.prototype.$axios
      .get("/orders/statuses", payload)
      .then(res => {
        commit("SET_ORDER_STATUSES", res.data.orderStatuses);
      });
  },
  DESTROY_ORDER: async function({ commit }, payload) {
    return await Vue.prototype.$axios.delete("/orders/" + payload);
  },
  LOAD_SUPPLIER_ORDERS: async function({ commit }, payload) {
    let surgeryIdQuery = payload.surgeryId
      ? "&surgeryId=" + payload.surgeryId
      : "";
    let orderStatusQuery = payload.orderStatus
      ? "&orderStatus=" + payload.orderStatus
      : "";
    let orderNumberQuery = payload.orderNumber
      ? "&orderNumber=" + payload.orderNumber
      : "";
    return await Vue.prototype.$axios
      .get(
        "/suppliers/" +
          payload.supplierId +
          "/orders?from=" +
          payload.from +
          "&limit=" +
          payload.to +
          surgeryIdQuery +
          paymentStatusQuery +
          orderNumberQuery
      )
      .then(res => {
        commit("SET_ORDERS", res.data.orders);
        commit("SET_TOTAL_ORDERS", res.data.meta.total);
      });
  },
  async UPDATE_SHIPPING_ADDRESS(context, payload) {
    await Vue.prototype.$axios.post("/shipments/" + payload.id, payload).then(
      res => {},
      err => {
        throw new Error(err.response.data.meta.errorCategory);
      }
    );
  }
};

const mutations = {
  SET_ORDERS: (state, orders) => {
    state.orders = orders;
  },
  SET_ORDER: (state, order) => {
    state.order = order;
  },
  SET_TOTAL_ORDERS: (state, total) => {
    state.totalOrders = total;
  },
  SET_ORDER_STATUSES: (state, payload) => {
    state.orderStatuses = payload;
  }
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
};
